import i18n from "@/utils/i18n";

// 菜单地址和跳转参数里的模块名是中文，英文界面改成对应文案
const MODULE_TITLE_KEY = {
  专题课: "homeResource.featuredClass",
  精品课: "homeResource.premumClass",
  精品课程: "homeResource.premumClass",
  课程资源: "homeData.courseRes",
  系列课: "homeResource.seriesClass",
  系列课程: "homeResource.seriesClass",
  在线课堂: "homeData.liveCourse",
  校园广播: "homeResource.campusBroadcast",
};

export function resolveModuleTitle(name) {
  const key = MODULE_TITLE_KEY[name];
  if (!key || i18n.global.locale.value !== "en") {
    return name;
  }
  return i18n.global.t(key);
}
